require('./bootstrap');

import {createApp, h} from 'vue';
import {createInertiaApp, Head, Link} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import VueMixin from './includes/vue-mixin.js';
import MomentPlugin from './includes/moment-plugin'
import Toasts from './includes/toasts'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import PapaParse from "./includes/papaparse";
import Chart from 'chart.js/auto';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faUserSecret, faSpinner, faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import {faStripe} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

library.add(faUserSecret, faSpinner, faStripe, faExclamationTriangle);

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';


createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({el, app, props, plugin}) {
        return createApp({render: () => h(app, props)})
            .use(plugin)
            .use(MomentPlugin)
            .use(Toasts)
            .use(VueSweetalert2)
            .use(PapaParse)
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .component('font-awesome-icon', FontAwesomeIcon)
            .mixin(VueMixin)
            .mount(el);
    },
});

InertiaProgress.init({color: '#7e3af2'});
